/* global axios */
import ApiClient from './ApiClient';

/**
 * Visual workflows. Every workflow carries two graphs: a draft the editor writes on every
 * keystroke, and a published graph the engine actually runs. That split is why publishing and
 * validating are endpoints of their own rather than fields on an update.
 */
class WorkflowsAPI extends ApiClient {
  constructor() {
    super('workflows', { accountScoped: true });
  }

  /**
   * Promotes the draft graph to published. Takes no body — the server publishes what is already
   * stored, so a stale editor cannot publish a graph the user never saved.
   * A graph the engine cannot run comes back 422 with { errors: [{ path, message }] }.
   */
  publish(id) {
    return axios.post(`${this.url}/${id}/publish`);
  }

  /**
   * Dry run. Answers whether a graph would publish, without storing it — the only way to warn
   * about a broken edge while the user is still drawing it.
   */
  validateGraph(graph) {
    return axios.post(`${this.url}/validate`, { graph });
  }

  /**
   * The block catalogue: every block kind the server knows, with its category, outputs and
   * params. The palette and the properties panel are both generated from this, so an engine
   * that grows a block does not need a matching frontend release.
   */
  blocks() {
    return axios.get(`${this.url}/blocks`);
  }

  /**
   * Turns a sentence into a graph. `graph` is the draft being refined, or null for a workflow
   * built from nothing — the server needs to know which of the two it is being asked for.
   * Answers { graph, credits_remaining }; 422 carries { error, errors: [{ path, message }] }
   * when nothing legal could be produced, and 402 when there is no credit left to spend.
   */
  build(payload) {
    return axios.post(`${this.url}/build`, payload);
  }
}

export default new WorkflowsAPI();
